"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STUDIO_VARIABLES = exports.ContentListReportUpdateMessageType = exports.SidebarPreviewItemType = exports.ActiveItemChangeMessageType = exports.SkipBackMessageType = exports.SkipForwardMessageType = exports.PauseMessageType = exports.PlayMessageType = void 0;
exports.PlayMessageType = "SP_PLAY_CONTROL_ACTION";
exports.PauseMessageType = "SP_PAUSE_CONTROL_ACTION";
exports.SkipForwardMessageType = "SP_SKIP_FORWARD_CONTROL_ACTION";
exports.SkipBackMessageType = "SP_SKIP_BACK_CONTROL_ACTION";
exports.ActiveItemChangeMessageType = "SP_ACTIVE_ITEM_CHANGE";
exports.SidebarPreviewItemType = "SP_PREVIEW_ITEM";
exports.ContentListReportUpdateMessageType = "SP_CONTENT_LIST_REPORT_UPDATE";
var STUDIO_VARIABLES;
(function (STUDIO_VARIABLES) {
    STUDIO_VARIABLES["$_SC_STUDIO_ORG_ID"] = "$_SC_STUDIO_ORG_ID";
    STUDIO_VARIABLES["$_SC_STUDIO_SPACE_ID"] = "$_SC_STUDIO_SPACE_ID";
    STUDIO_VARIABLES["$_SC_STUDIO_SCREEN_ID"] = "$_SC_STUDIO_SCREEN_ID";
    STUDIO_VARIABLES["$_SC_STUDIO_CHANNEL_ID"] = "$_SC_STUDIO_CHANNEL_ID";
    STUDIO_VARIABLES["$_SC_STUDIO_LAYOUT_ID"] = "$_SC_STUDIO_LAYOUT_ID";
    STUDIO_VARIABLES["$_SC_STUDIO_PLAYLIST_ID"] = "$_SC_STUDIO_PLAYLIST_ID";
    STUDIO_VARIABLES["$_SC_STUDIO_APP_INSTANCE_ID"] = "$_SC_STUDIO_APP_INSTANCE_ID";
    STUDIO_VARIABLES["$_SC_STUDIO_FILE_ID"] = "$_SC_STUDIO_FILE_ID";
    STUDIO_VARIABLES["$_SC_STUDIO_LINK_ID"] = "$_SC_STUDIO_LINK_ID";
    STUDIO_VARIABLES["$_SC_STUDIO_SITE_ID"] = "$_SC_STUDIO_SITE_ID";
    STUDIO_VARIABLES["$_SC_STUDIO_CONTENT_TYPE"] = "$_SC_STUDIO_CONTENT_TYPE";
})(STUDIO_VARIABLES = exports.STUDIO_VARIABLES || (exports.STUDIO_VARIABLES = {}));
